import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, timeout } from "rxjs/operators";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.authService.token && this.authService.token.hash) {
            request = request.clone({
                setHeaders: {
                    authorization: `Bearer ${this.authService.token.hash}`,
                },
            });
        }

        const timeoutValue = request.headers.get("timeout") || 60000;

        return next.handle(request).pipe(
            timeout(Number(timeoutValue)),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    if (this.authService.token) {
                        this.authService
                            .loginRefreshToken()
                            .then(() => {
                                return next.handle(request);
                            })
                            .catch(() => this.authService.logout());
                    } else {
                        this.authService.logout();
                    }
                    const authError = new HttpErrorResponse({
                        error: "Sua sessão expirou. Por favor, faça login novamente.",
                        status: 401,
                        statusText: "Não Autorizado",
                        url: err.url || undefined,
                    });
                    return throwError(authError);
                }
                return throwError(err);
            })
        );
    }
}
